import { writable } from './svelte';
import { get_store_value } from './svelte/util';

/**
 * Creates a new CSS stylesheet with the given string.
 * @param {string} source 
 * @returns {CSSStyleSheet}
 */
export function newCss(source) {
	const sheet = new CSSStyleSheet();
	sheet.replaceSync(source);
	return sheet;
}

function styleStore() {

	/** @type {CSSStyleSheet[]} */
	const _sheets = [];

	const { update, subscribe } = writable(_sheets);

	return {
		subscribe,

		/**
		 * @param {CSSStyleSheet | string | CSSStyleSheet[] | string[] | null} v 
		 */
		add(v) {
			if (!v) throw new Error("Tried to add null or undefined value to sharedStyles.");

			/**
			 * @param {CSSStyleSheet | string} x 
			 * @returns {CSSStyleSheet}
			 */
			const convert = (x) => typeof(x) === "string" ? newCss(x) : x;

			/** @type {CSSStyleSheet[]} */
			let sheets = [];
			if (!Array.isArray(v)) {
				sheets = [convert(v)];
			} else {
				sheets = v.map(convert);
			}
			update(s => {
				s.push(...sheets);
				return s;
			});
		},

		refresh() {
			update(s => s);
		},

		get value() { return _sheets },
	}
}

export const sharedStyles = styleStore();

export default sharedStyles;
